export const clamp = (v: number, min: number, max: number): number =>
  v < min ? min : v > max ? max : v;

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Framerate-unabhaengiges Glaetten. `rate` = wie schnell (groesser = schneller). */
export const damp = (a: number, b: number, rate: number, dt: number): number =>
  lerp(a, b, 1 - Math.exp(-rate * dt));

/** Bewegt `a` mit maximal `maxDelta` Richtung `b`. */
export const moveTowards = (a: number, b: number, maxDelta: number): number => {
  const d = b - a;
  if (Math.abs(d) <= maxDelta) return b;
  return a + Math.sign(d) * maxDelta;
};

export const smoothstep = (t: number): number => {
  const x = clamp(t, 0, 1);
  return x * x * (3 - 2 * x);
};

/** Kleine Totzone um 0, danach linear auf volle Reichweite skaliert. */
export const deadzone = (v: number, dz: number): number => {
  const a = Math.abs(v);
  if (a <= dz) return 0;
  return Math.sign(v) * ((a - dz) / (1 - dz));
};
